<template>
  <transition
    appear
    @enter="4800"
    @leave="2000"
    name="fade"
    mode="out-in"
    >
    <div
      class="modiface modiface-area"
      key='modiface-wrap-key'
      >
    <transition name="fade">
      <img
        ref="stream"
        :src="streamUrl"
        alt=""
        key='modiface-img-key'
        :style="{ transform: transform, marginLeft: offsetX, marginTop: offsetY }">
    </transition>
    </div>
  </transition>
</template>
<script>

export default {
  name: 'modiface',
  computed: {
    offsetX () {
      return `0px`
    },
    offsetY () {
      return `0px`
    },
    transform () {
      return `translate(-50%, -50%) scale(1, 1)`
    },
    streamUrl () {
      return `${this.$sdk.baseURL}/stream.mjpeg`
    }
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
  .modiface {
    // position: fixed;
    height: 53.5vh;
    margin-top: 66px;
    overflow: hidden;
    text-align: center;
    width: 100%;
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: auto;
    }
  }
</style>
